<div class="page-header ">
  <div class="flex xl:align-items-center flex-wrap xl:flex-nowrap gap-3 w-full">
    <div class="flex-grow-1">
      <app-primeng-breadcrumb></app-primeng-breadcrumb>
    </div>
    <div class="right-container flex flex-wrap xl:flex-nowrap gap-3 justify-content-end">
      <p-iconField iconPosition="left">
        <p-inputicon> <i-tabler name="search" class="it-normal ti-base"></i-tabler></p-inputicon>
        <input type="text" pInputText [(ngModel)]="searchTerm"
          placeholder="Search Application" />
      </p-iconField>
    </div>

  </div>
</div>


<div class="page-content mt-2" >
  <!-- <app-skeleton id="table-items" *ngIf="loading" [columns]="tableConfig" [paginator]="true"></app-skeleton> -->
  <p-table [value]="tableData | searchFilter:searchTerm:'applicationName'" styleClass="p-datatable-gridlines" class="m-0" *ngIf="!loading" [pageLinks]="3" [paginator]="tableData?.length > 10" [rows]="10"  [first]="first"
    [rowsPerPageOptions]="[5, 10, 25, 50, 100]"  (onPage)="onPageChange($event)" [showCurrentPageReport]="false" [showJumpToPageInput]="false" paginatorStyleClass="justify-content-end"  responsiveLayout="scroll">
    <ng-template pTemplate="header">
      <tr>
        <th rowspan="2" class="text-center" id="applicationName">Application Name</th>
        <th colspan="3" class="text-center" id="listOfResources">List of Resources</th>
        <th rowspan="2" id="others" class="text-center">Others</th>
      </tr>
      <tr>
        <!-- <th id="urls" class="text-center">URL'S</th> -->
        <th id="dashboards" class="text-center">Dashboards</th>
        <th id="widgets" class="text-center">Widgets</th>
        <th id="apis" class="text-center">API'S</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-app>
      <tr>
        <td><span class="name">{{ app.applicationName }}</span></td>
        <!-- <td>
          <ng-container *ngIf="app.resources?.URLs?.length">
            <div class="flex flex-wrap gap-2">
              <button *ngFor="let url of app.resources.URLs" pButton type="button"
                label="{{url.resourceName | titlecase}} ({{actionNameMapping[url.resourceActionName]}})" size="small"
                ></button>
            </div>
          </ng-container>
          <div *ngIf="!app.resources?.URLs?.length">-</div>
        </td> -->
        <td>
          <ng-container *ngIf="app.resources?.Dashboards?.length">
            <div class="flex flex-wrap gap-2">
              <button *ngFor="let dash of app.resources.Dashboards" pButton type="button"
                label="{{dash.resourceName | titlecase}} " size="small"
                ></button>
            </div>
          </ng-container>
          <div *ngIf="!app.resources?.Dashboards?.length">-</div>
        </td>

        <td>
          <ng-container *ngIf="app.resources?.Widgets?.length">
            <div class="flex flex-wrap gap-2">
              <button *ngFor="let widget of app.resources.Widgets" pButton type="button"
                label="{{widget.resourceName | titlecase}} ({{actionNameMapping[widget.resourceActionName]}})"
                size="small" ></button>
            </div>
          </ng-container>
          <div *ngIf="!app.resources?.Widgets?.length">-</div>
        </td>
        
        <td>
          <ng-container *ngIf="app.resources?.APIs?.length">
            <div class="flex flex-wrap gap-2">
              <button *ngFor="let api of app.resources.APIs" pButton type="button"
                label="{{api.resourceName | titlecase}} " size="small"
                ></button>
            </div>
          </ng-container>
          <div *ngIf="!app.resources?.APIs?.length">-</div>
        </td>

        <td>
          <ng-container *ngIf="app.resources?.Others?.length">
            <div class="flex flex-wrap gap-2">
              <button *ngFor="let item of app.resources.Others" pButton type="button"
                label="{{item.resourceName | titlecase}}" size="small"
                ></button>
            </div>
          </ng-container>
          <div *ngIf="!app.resources?.Others?.length">-</div>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
          <td [attr.colspan]="6">
              <div class="text-center p-3 text-500">
                  {{ 'No Applications to Display.'}}
              </div>
          </td>
      </tr>
  </ng-template>
  <ng-template pTemplate="paginatorleft">
    {{first+1}} to {{first + rows}}
</ng-template>
  </p-table>
</div>
<p-toast />